import React from 'react'
import { I18n } from '@front/volcanion/'

import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'
import { TextField, DateTimeField } from '@front/squirtle'

const Row1 = () =>
  <Grid container spacing={1} size={12}>
    <Grid size={12}>
      <TextField
        name='title'
        label={I18n.t('title.label', { count: 1 })}
        disabled
      />
    </Grid>
  </Grid>

const Row2 = () =>
  <Grid container spacing={1} size={12}>
    <Grid>
      <TextField
        name='commercial_package.name'
        label={I18n.t('commercialpackage.label', { count: 1 })}
        disabled
      />
    </Grid>
    <Grid>
      <DateTimeField
        name='requestedAt'
        label={I18n.t('date.label.full')}
        compact
        disabled
      />
    </Grid>
    <Grid>
      <TextField
        name='service.contract.company.name'
        label={I18n.t('company.label', { count: 1 })}
        disabled
      />
    </Grid>
    <Grid>
      <TextField
        name='source.postal_code'
        label={I18n.t('address.start')}
        disabled
      />
    </Grid>
    <Grid>
      <TextField
        name='destination.postal_code'
        label={I18n.t('address.destination')}
        disabled
      />
    </Grid>
    <Grid>
      <TextField
        name='payment_type.name_translated'
        label={I18n.t('payment.label', { count: 1 })}
        disabled
      />
    </Grid>
  </Grid>


const JobInfoSection = (props) => <>
  <StepLabel>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant='h6'>{I18n.t('message.label', { count: 1 })}</Typography>
    </Box>
  </StepLabel>
  <StepContent>
    <Grid container rowSpacing={4} >
      <Row1 />
      <Row2 />
    </Grid>
  </StepContent>
</>

export default JobInfoSection
